import type React from "react";

interface Props {
  size?: number;
  color?: string;
}

export function RightHalfIcon(props: Props): React.ReactNode {
  const { size = 24, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title>Right Half</title>
      <path
        d="M2.74997 12.3356C2.74997 7.51499 6.78862 3.56429 11.811 3.46738L11.811 21.2037C6.78862 21.1068 2.74997 17.1561 2.74997 12.3356Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M12.061 21.4556C17.271 21.424 21.5 17.3447 21.5 12.3357C21.5 7.32676 17.271 3.24753 12.061 3.21594L12.061 21.4556Z"
        fill="currentColor"
      />
    </svg>
  );
}
